import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { FieldType } from '../Types/Field'
import MuiTextField from '@mui/material/TextField'
import * as R from 'ramda'
import { useTranslation } from 'react-i18next'
import { ReadOnlyContext } from '../Providers/ReadOnlyProvider'

/**
 * A wrapper to make it easy to add functionality, i.e. clearable
 */
const TextField = ({ value, exactLength, maxLength, countChars, ...props }) => {
  const { t } = useTranslation()
  const { readOnly } = useContext(ReadOnlyContext)

  // get rid of "I don't want null" fucking message from MUI
  const val = R.ifElse(R.isNil, () => '', R.identity)(value)
  let helperText =
    props.helperText ||
    (exactLength
      ? t('common:ui.CharactersCount', {
          count: val.length,
          total: exactLength,
        })
      : '')
  if (countChars) {
    helperText +=
      ' / ' + t('common:ui.CharactersCountNoTot', { count: val.length })
  }
  if (maxLength) {
    props.inputProps = { ...R.defaultTo({}, props.inputProps), maxLength }
  }
  return (
    <MuiTextField
      value={val}
      InputProps={{
        readOnly: readOnly || props.readonly,
      }}
      {...props}
      helperText={helperText}
      variant={props.variant}
    />
  )
}

TextField.defaultProps = {
  variant: 'standard',
}

TextField.propTypes = {
  ...FieldType,
  maxLength: PropTypes.number,
  exactLength: PropTypes.number,
  variant: PropTypes.string,
}

export default TextField
